<template>
  <div class="form-item" v-show="item.visible">
    <!-- {{item.defaultValue}}"123" -->
    <!-- {{item.prompt}} -->
    <el-tooltip class="item" effect="dark" placement="top-start" v-if="item.description">
      <div slot="content">{{item.description}}</div>
      <img class="form-tooltip" :src="require('@/assets/question.png')" />
    </el-tooltip>
    <el-form-item :label="localized(`label`)" :rules="rules" :prop="item.prop">
      <el-input
        v-model="itemdata"
        :placeholder="localized(`prompt`) || ''"
        :disabled="!item.editable"
        @focus="showInputView"
        class="rt-input"
      ></el-input>
    </el-form-item>

    <el-dialog
      :title="localized(`label`)"
      :visible.sync="showInputArea"
      top="15vh"
      class="input-dialog"
      width="90%"
    >
      <el-input
        type="textarea"
        v-model="tempData"
        :placeholder="localized(`prompt`) || ''"
        :disabled="!item.editable"
        :autosize="{ minRows: 4}"
        ref="inputRef"
        :autofocus="true"
        style="margin-top: -20px;"
      ></el-input>
      <el-row type="flex" class="row-bg" justify="space-between" style="margin-top: 20px;">
        <el-col :span="11">
          <el-button
            @click="rollbackData"
            size="small"
            round
            class="btn-white-color"
          >{{$t('app.btn_clear')}}</el-button>
        </el-col>
        <el-col :span="11">
          <el-button
            @click="confirmData"
            size="small"
            round
            class="btn-white-color"
          >{{$t('app.btn_confirm')}}</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>


<script>
import utils from "@/utils";
import language from "@/lang";
import callApp from "@/services/sdk";
export default {
  name: "input-widget",
  props: {
    editable: { type: Boolean },
    item: { type: Object },
    value: [String, Object, Number]
  },
  data() {
    return {
      rules: utils.generateFormRule(this.item),
      showInputArea: false,
      tempData: "",
      inputRef: "inputRef"
    };
  },
  computed: {
    itemdata: {
      get() {
        return this.value;
      },
      set(itemdata) {
        this.$emit("input", itemdata);
      }
    }
  },
  methods: {
    callApp(type) {
      if (!this.item.editable) {
        return;
      }
      if (type === "qrcode") {
        callApp("getQrcodeContent", {}, "cbGetQrcodeContent").then(data => {
          this.itemdata = data;
        });
      }
    },
    localized(key) {
      return language.localize(
        this.$store.state,
        this.item.name,
        key,
        this.item[key]
      );
    },
    showInputView() {
      this.showInputArea = true;
      this.tempData = this.itemdata;
      this.$nextTick(() => {
        this.$refs["inputRef"].focus();
      });
    },
    confirmData() {
      this.showInputArea = false;
      this.itemdata = this.tempData;
    },
    rollbackData() {
      this.showInputArea = false;
      this.tempData = this.itemdata;
    }
  },
  created() {
    if (this.value != undefined) {
      if (typeof this.value == "string" && this.value.length > 0) {
        this.itemdata = this.value;
      } else {
        this.itemdata = this.item.defaultValue;
      }
    } else {
      this.itemdata = this.item.defaultValue;
    }
  }
};
</script>
<style lang="scss" >
.rt-input {
  &.el-input.is-disabled .el-input__inner {
    background-color: #f5f7fa !important;
    border-color: transparent !important;
    color: black !important;
    cursor: not-allowed !important;
  }

  input:disabled {
    opacity: 1 !important;
  }
}
</style>

